import Grid from "@material-ui/core/Grid";
import TextField from "@mui/material/TextField";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import { useSelector } from "react-redux";
import EditButton from "../../Utils/Botones/EditButton";
import NewButton from "../../Utils/Botones/NewButton";
import DataTable from "../../Utils/DataTables";
import { getRequest } from "../../Utils/Funciones/requester";
import Contenedor from "../../Utils/Visuales/Contenedor";
import NewModal from "../../Utils/Visuales/NewModal";
import { orderSchedules } from "../../Utils/Funciones/orderSchedules";
import {
  headers,
  headersCalendario,
  headersDetalleCalendario,
  headersModal,
} from "../../Utils/data/horario";
import { sortDateArray } from "../../Utils/Funciones/sortDateArray";
import { ExportCSV } from "../../Utils/Excel";

function Horario2() {
  const { enqueueSnackbar } = useSnackbar();
  const [modalConsultarIsOpen, setModalConsultarIsOpen] = useState(false);
  const [loadingCalendario] = useState(false);
  const [dataDetalleCalendario, setDataDetalleCalendario] = useState([]);
  const [loadingDetalleCalendario] = useState(false);
  const [openHorarioDetail, setOpenHorarioDetail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [profesorValue, setProfesorValue] = useState({
    label: "",
    value: "",
  });
  const [valueCiclo, setValueCiclo] = useState("");
  const [data, setData] = useState([]);
  const [dataFechasEspeciales, setDataFechasEspeciales] = useState([]);
  const id_campus = useSelector((state) => state.campusId);
  const [loadingModal, setLoadingModal] = useState(false);

  useEffect(() => {
    getCicloOptions(enqueueSnackbar);
  }, [enqueueSnackbar]);

  const getCicloOptions = async (enqueueSnackbar) => {
    try {
      const consulta = `/buscar?tipo=ciclo&valor=`;
      const response = await getRequest(consulta);
      let data = [];
      if (response.s === "OK") {
        for (let i = 0; i < response.d.length; i++) {
          data.push({
            idRow: i,
            value: response.d[i],
            label: response.d[i],
          });
        }
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  async function searchProfesor(valor) {
    try {
      const options = [];

      const consulta = `/buscar?tipo=profesor&valor=${valor}`;
      //console.log(consulta);
      const response = await getRequest(consulta);

      if (response.s === "OK") {
        response.d.forEach((item) => {
          options.push({
            label: item.nss + " - " + item.nombre,
            value: item.id,
          });
        });

        return options;
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar(error, {
        variant: "error",
        autoHideDuration: null,
      });
    }
  }
  const minChars = 5;
  const waitTime = 2000;

  let timer;
  const asyncSelectStyles = {
    container: (styles) => ({ ...styles, zIndex: 9 }),
  };
  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      clearTimeout(timer);
      if (inputValue.length >= minChars) {
        timer = setTimeout(() => {
          resolve(searchProfesor(inputValue));
        }, waitTime);
      } else {
        resolve([]);
      }
    });

  const labelStyles = { marginTop: "15px", display: "block", float: "right" };

  const openModalConsultar = async (id) => {
    setOpenHorarioDetail(true);
    setLoadingModal(true);
    const url = `/asignaciones/detalle-consulta?id=${id}`;
    const response = await getRequest(url);
    if (response.s === "OK") {
      const dataForTable = orderSchedules(
        response.d,
        `${profesorValue?.label?.split(" - ")?.[0]}`
      );
      setDataFechasEspeciales(
        dataForTable.filter((element) => element[2] !== "01-01-1900")
      );
      setLoadingModal(false);
    } else {
      setLoadingModal(false);
    }
  };

  const getDataTableHorario = async () => {
    let valido = true;
    if (profesorValue.value === "") {
      enqueueSnackbar("Falta Seleccionar Clave Profesor", {
        variant: "error",
        autoHideDuration: null,
      });
      valido = false;
    }
    if (valueCiclo === "") {
      enqueueSnackbar("Falta llenar campo Ciclo", {
        variant: "error",
        autoHideDuration: null,
      });
      valido = false;
    }
    if (profesorValue.value === "") {
      enqueueSnackbar("Falta Seleccionar Clave Profesor", {
        variant: "error",
        autoHideDuration: null,
      });
      valido = false;
    }
    if (valido) {
      setLoading(true);
      try {
        const profesorValueF = profesorValue.value;
        let consulta = `/asignaciones/horario?id_campus=${id_campus}&id_profesor=${profesorValueF}&ciclo=${valueCiclo}`;

        const response = await getRequest(consulta);
        const datos = [];
        if (response.s === "OK") {
          if (response.d.length === 0 || response.d === "") {
            setData([]);
            enqueueSnackbar("No se han encontrado datos", {
              variant: "info",
            });
            setLoading(false);
          } else {
            for (let i = 0; i < response.d[0]["campus"].length; i++) {
              datos.push([
                response.d[0]["campus"][i],
                response.d[1]["escuela"][i],
                response.d[2]["direccion"][i],
                response.d[3]["director"][i],
                response.d[4]["grupo"][i],
                response.d[5]["clave_materia"][i],
                response.d[6]["nombre_materia"][i],
                response.d[7]["lun"][i],
                response.d[8]["mar"][i],
                response.d[9]["mie"][i],
                response.d[10]["jue"][i],
                response.d[11]["vie"][i],
                response.d[12]["sab"][i],
                response.d[13]["dom"][i],
                response.d[14]["salon"][i],
                response.d[15]["tipo_profesor"][i],
                response.d[16]["tipo_grupo"][i],
                response.d[17]["tipo_asistencia"][i],
                response.d[18]["modulo"][i],
                response.d[19]["horas_semana"][i],
                response.d[25]["metodo"][i] !== "ONLN"
                  ? "-"
                  : response.d[20]["semanas"][i],
                response.d[21]["fecha_alta"][i] === "None"
                  ? "-"
                  : response.d[21]["fecha_alta"][i],
                response.d[22]["fecha_baja"][i] === "None"
                  ? "-"
                  : response.d[22]["fecha_baja"][i],
                response.d[23]["fechas"][i] !== "" ? (
                  <div I="edit" a="horario">
                    <EditButton
                      onClick={() => {
                        openModalConsultar(response.d[26]["id"][i]);
                      }}
                    >
                      Consultar
                    </EditButton>
                  </div>
                ) : (
                  ""
                ),
                response.d[26]["id"][i],
              ]);
            }
            setData(datos);
            enqueueSnackbar(response.m, {
              variant: "success",
            });
            setLoading(false);
          }
        } else {
          setLoading(false);
          enqueueSnackbar(response.m, {
            variant: "error",
            autoHideDuration: null,
          });
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
    }
  };

  const getDetalleCalendario = (e) => {
    let data = [];
    const data_detalle = e.at(-1);
    data_detalle.forEach((calendario) => {
      data.push([
        calendario.clave_profesor,
        calendario.nombre_profesor,
        calendario.tipo_profesor,
        calendario.fecha,
        calendario.dia,
        calendario.inicia,
        calendario.termina,
        calendario.modulo,
        calendario.horas_por_semanas,
        calendario.semanas,
        calendario["Fecha de Alta"],
        calendario.fecha_baja,
      ]);
    });
    setDataDetalleCalendario(data);
  };

  const DownloadExcel = async () => {
    setLoading(true);
    const dataTable = [];
    for (let i in data) {
      const objectData = {
        Ciclo: valueCiclo,
        Profesor: profesorValue?.label,
        ...Object.fromEntries(
          data[i].map((_, index) => [
            headers[index]?.name ? headers[index]?.name : "id",
            data[i][index],
          ])
        ),
      };
      if (objectData["Fechas"] !== "") {
        const url = `/asignaciones/detalle-consulta?id=${objectData.id}`;
        const response = await getRequest(url);
        if (response.s === "OK") {
          const dataForTable = orderSchedules(
            response.d,
            `${profesorValue?.label?.split(" - ")?.[0]}`
          );
          objectData["Fechas"] = sortDateArray(
            dataForTable
              .filter((element) => element[2] !== "01-01-1900")
              .map((element) => element[2])
          )
            ?.map((date) => {
              const splitDate = date?.split("-");
              return `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;
            })
            ?.join(", ");
        }
      }
      objectData["Salón"] = objectData["Salón"].replace(/,/g, ", ");
      delete objectData["id"];
      dataTable.push(objectData);
    }
    var today = new Date();
    var fecha = `${today.getFullYear()}${
      today.getMonth() + 1
    }${today.getDate()}`;
    var hora = `${today.getHours()}${today.getMinutes()}`;
    ExportCSV(dataTable, `Asignaciones_Horario_${fecha}_${hora}`);
    setLoading(false);
  };

  return (
    <Contenedor title="Asignaciones / Horario">
      <div className="inputs-excepciones">
        <Grid container style={{ position: "relative" }}>
          <Grid container item xs={12}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item xs={1} style={{ textAlign: "end" }}>
                <label>Ciclo(*):</label>
              </Grid>
              <Grid item xs={2} style={{ zIndex: 99 }}>
                <input
                  className="filter-input"
                  value={valueCiclo}
                  onChange={(e) => setValueCiclo(e.target.value)}
                />
              </Grid>
              <Grid item lg={2} md={2} style={{ textAlign: "end" }}>
                <label>Clave Profesor(*):</label>
              </Grid>
              <Grid item lg={3} md={2} style={{ zIndex: 99 }}>
                <AsyncSelect
                  className="select-modal-container"
                  classNamePrefix="select-modal"
                  styles={asyncSelectStyles}
                  loadOptions={promiseOptions}
                  onChange={setProfesorValue}
                />
              </Grid>
              <Grid item xs={1} justifyContent="flex-end" container>
                <NewButton
                  customText="Buscar"
                  noIcon
                  style={{ padding: "5px 15px", marginLeft: "auto" }}
                  onClick={(e) => {
                    getDataTableHorario();
                  }}
                />
              </Grid>
              <Grid item xs={1} justifyContent="flex-end" container>
                <NewButton
                  customText="Descargar"
                  noIcon
                  disabled={!data?.length}
                  style={{ padding: "5px 15px", marginLeft: "auto" }}
                  onClick={DownloadExcel}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>

      <div style={{ height: "calc(100% - 85px)" }}>
        <DataTable
          headers={headers}
          data={data}
          loading={loading}
          centrar={[1, 2, 3, 4, 5, 6]}
          paginate
          bordes
        />
      </div>

      <NewModal
        title="Fechas Especiales"
        open={openHorarioDetail}
        handleClose={() => {
          setOpenHorarioDetail(false);
        }}
        height={"50vh"}
        maxWidth={"50%"}
        noSaveBtn
        loading={loadingModal}
      >
        <div style={{ height: "90%", overflowY: "hidden", marginTop: "10px" }}>
          <div style={{ height: "100%", overflowY: "hidden" }}>
            <DataTable
              headers={headersModal}
              data={dataFechasEspeciales}
              loading={loadingDetalleCalendario}
              centrar={[1, 2, 3, 4]}
              paginate
              bordes
            />
          </div>
        </div>
      </NewModal>

      <NewModal
        title="Consultar Horario"
        open={modalConsultarIsOpen}
        handleClose={() => {
          setDataDetalleCalendario([]);
          setModalConsultarIsOpen(false);
        }}
        height={"80vh"}
        maxWidth={"90%"}
        noSaveBtn
        loading={loadingModal}
      >
        <div style={{ padding: "25px" }}>
          <Grid
            container
            spacing={2}
            style={{ marginTop: "-2%", alignItems: "center" }}
          >
            <Grid item xs={2}>
              <label style={labelStyles}>Clave Profesor:</label>
            </Grid>
            <Grid item xs={4}>
              <input
                disabled
                className="filter-input"
                style={{
                  width: "100%",
                  marginRight: "10px",
                  marginTop: "15px",
                }}
              ></input>
            </Grid>
            <Grid item xs={1}>
              <label style={labelStyles}>Tipo:</label>
            </Grid>
            <Grid item xs={4}>
              <input
                disabled
                className="filter-input"
                style={{ marginTop: "15px" }}
              />
            </Grid>

            <Grid item xs={2} style={{ marginTop: "-1%" }}>
              <label style={labelStyles}>Fecha Inicial:</label>
            </Grid>
            <Grid item xs={2} style={{ marginTop: "-1%" }}>
              <TextField
                disabled
                className="filter-input-fecha"
                label="Seleccionar fecha"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                style={{ width: "170px", marginTop: "15px" }}
              />
            </Grid>
            <Grid item xs={1} />
            <Grid item xs={2} style={{ marginTop: "-1%" }}>
              <label style={labelStyles}>Fecha Final:</label>
            </Grid>
            <Grid item xs={2} style={{ marginTop: "-1%" }}>
              <TextField
                disabled
                className="filter-input-fecha"
                label="Seleccionar fecha"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                style={{ width: "170px", marginTop: "15px" }}
              />
            </Grid>
          </Grid>
        </div>

        <div
          style={{
            height: "calc(100% - 120px)",
            overflowY: "scroll",
            marginTop: "-1%",
          }}
        >
          <div style={{ height: "45%", minHeight: "200px" }}>
            <label style={{ margin: "10px 0", display: "block" }}>
              Calendario
            </label>
            <DataTable
              headers={headersCalendario}
              data={[]}
              loading={loadingCalendario}
              centrar={[1, 2, 3, 4]}
              paginate
              bordes
              onClickRow={(e) => getDetalleCalendario(e)}
            />
          </div>

          <div style={{ height: "45%", minHeight: "200px" }}>
            <label style={{ margin: "10px 0", display: "block" }}>
              Detalle Horario
            </label>
            <DataTable
              headers={headersDetalleCalendario}
              data={dataDetalleCalendario}
              loading={loadingDetalleCalendario}
              centrar={[1, 2, 3, 4]}
              paginate
              bordes
            />
          </div>
        </div>
      </NewModal>
    </Contenedor>
  );
}

export default Horario2;
